
import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";

export default class VentanaQueryItems extends Ventana {
    constructor() {
        super();
        this.ventanaCargando = null
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaQueryItems)) {
            return false;
        }

        return true;
    }

    clonar(){
        const nuevaVentana = new VentanaQueryItems();
        nuevaVentana.id              = this.id;
        nuevaVentana.posicionZ       = this.posicionZ         
        nuevaVentana.ventanaCargando = this.ventanaCargando
        return nuevaVentana;
    }
}
